import { Suspense, lazy } from 'react';
import SidebarLayout from 'src/layouts/SidebarLayout';
import SuspenseLoader from 'src/parts/SuspenseLoader';
import { useAppSelector } from './store'; // بردان
import { Route, Routes, useLocation } from 'react-router';
import VwKullaniciRolyetkiDTO from './models/RolYetki/VwKullaniciRolyetkiDTO';
import HastalikTanim from './content/pages/GenelTanimlar/HastalikTanim';
import RaporPeronel from './content/pages/Raporlama/Tanim/RaporPersonel';
import KurumBonusTanimlari from './content/pages/Settings/KurumBonuslari';
import KurumBonusTanimlariTestBazli from './content/pages/Settings/KurumBonuslari/TestBazli';
import KurumBonusTanimlariTestVeVeriyeGore from './content/pages/Settings/KurumBonuslari/TestVeriyeGore';
import KurumMailGonderimAyarlari from './content/pages/GenelTanimlar/KurumMailGonderimAyarlari';
import SonucIzlemeTanim from './content/pages/GenelTanimlar/SonucIzlemeTanim';


const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const isMenuAuthenticatedForUser = (arr: Array<VwKullaniciRolyetkiDTO>, menuLink) => {
  if (!arr) return false;

  if (menuLink === '/duyuru') return true;
  if (menuLink === '/login') return true;
  if (menuLink === '/logout') return true;
  if (menuLink?.indexOf('report') > -1) return true;

  if (menuLink?.indexOf('kimlik-detay') > -1) return true;

  if (menuLink === '/') return true;
  if (arr.length === 0) return false;

  let result = false;
  arr.forEach((item) => {
    if (item.link && item.link === menuLink) result = true;
  });
  return result;
};

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const userInfo = useAppSelector((state) => state.userLogin);

  const location = useLocation();
  const from = location?.pathname; //(location.state as any)?.from?.pathname
  const menuSlice = useAppSelector((state) => state.menuAuth);
  let userMenu = menuSlice.data.map((m) => m);
  let arr = from?.split('/');
  arr = arr.slice(0, -1);
  if (userMenu.length > 0)
    if (userMenu.filter((f) => f.link === from)?.length === 0) {
      if (userMenu.filter((f) => f.link === arr.join('/'))) {
        userMenu.push({
          link: from
        });
      }
    }

  const { organizasyon } = useAppSelector((s) => s.userOrganizasyon);
  if (!userInfo.userInfo.accessToken || !organizasyon.fkOrganizasyon) return <Login></Login>;
  else if (from !== '/') {
    const isUserAuthenticated = isMenuAuthenticatedForUser(userMenu, from);
    if (!isUserAuthenticated) return <Status404 />;
  }

  return children;
};

// Pages
const Login = Loader(lazy(() => import('src/content/pages/Login')));
const Logout = Loader(lazy(() => import('src/content/pages/Logout')));
const IslemTanim = Loader(lazy(() => import('src/content/pages/GenelTanimlar/IslemTanimlari/Islemler')));
const IslemBolum = Loader(lazy(() => import('src/content/pages/GenelTanimlar/IslemTanimlari/IslemBolum')));
const IstemPanel = Loader(lazy(() => import('src/content/pages/GenelTanimlar/IstemPanelTanimi/IstemPanel')));
const IstemPanelHasta = Loader(lazy(() => import('src/content/pages/GenelTanimlar/IstemPanelTanimi/IstemPanelHasta')));

const IstemPanelTanim = Loader(lazy(() => import('src/content/pages/GenelTanimlar/IstemPanelTanimi/IstemPanelTanim/index')));
const TeleDiagnosisTanim = Loader(lazy(() => import('src/content/pages/Settings/Generals/TeleDiagnosisTanim')));
const ServisTanim = Loader(lazy(() => import('src/content/pages/Settings/Generals/ServisTanim')));
const BransTanim = Loader(lazy(() => import('src/content/pages/Settings/Generals/bransTanim')));
const ParametreTanimlari = Loader(lazy(() => import('src/content/pages/Settings/Generals/ParametreTanim')));
const KurumTanim = Loader(lazy(() => import('src/content/pages/Settings/Generals/KurumTanimTarife')));
const GnlRolTanim = Loader(lazy(() => import('src/content/pages/Settings/Generals/rolTanim')));
const YetkiTanim = Loader(lazy(() => import('./content/pages/Yetki/YetkiTanim/index')));
const ModulTanim = Loader(lazy(() => import('./content/pages/Settings/Generals/modulTanim')));
const KurumTarife = Loader(lazy(() => import('./content/pages/kurumTarife/index')));
const OrganizasyonTarife = Loader(lazy(() => import('./content/pages/OrganizasyonTarife/index')));
const KullaniciTarife = Loader(lazy(() => import('./content/pages/KullaniciTarife/index')));
const TarifeIslem = Loader(lazy(() => import('./content/pages/ucretTarifeIslem/index')));
const UcretTarifeTanim = Loader(lazy(() => import('./content/pages/Settings/Generals/UcretTarifeTanim/index')));
const IndirimTanim = Loader(lazy(() => import('src/content/pages/Settings/Generals/indirimTanim')));
const ServisPersonel = Loader(lazy(() => import('src/content/pages/servisPersonelYetki')));
const OrganizasyonYetki = Loader(lazy(() => import('./content/pages/OrganizasyonYetki')));
const RolYetkiIndex = Loader(lazy(() => import('./content/pages/RolYetki')));

const Status404 = Loader(lazy(() => import('src/content/pages/Status/Status404')));
const Status500 = Loader(lazy(() => import('src/content/pages/Status/Status500')));
const StatusComingSoon = Loader(lazy(() => import('src/content/pages/Status/ComingSoon')));
const StatusMaintenance = Loader(lazy(() => import('src/content/pages/Status/Maintenance')));

const KullaniciTanim = Loader(lazy(() => import('src/content/pages/GenelTanimlar/KullaniciTanim')));
const KullaniciTanimDetay = Loader(lazy(() => import('src/content/pages/GenelTanimlar/KullaniciTanim/Detay')));

//Vezne
const VezneTanim = Loader(lazy(() => import('src/content/pages/Vezne/VezneTanim/VezneTanimListe')));
const VezneIndex = Loader(lazy(() => import('src/content/pages/Vezne')));

const FaturaMain = Loader(lazy(() => import('src/content/pages/Fatura')));

// authority
const KullaniciYetkiIndex = Loader(lazy(() => import('./content/pages/Yetki')));
const OrganizasyonTanim = Loader(lazy(() => import('./content/pages/Settings/Generals/OrganizasyonTanim')));

const RezervBarkod = Loader(lazy(() => import('src/content/pages/RezervBarkod')));

const VeznePosCihazTanim = Loader(lazy(() => import('src/content/pages/Vezne/PosCihazTanim/PosCihazTanimListe')));

//Kurum Dışı
const KurumDisiKargoKuryeIslemleri = Loader(lazy(() => import('./content/pages/KurumDisiKargoKuryeIslemleri')));
const KurumDisiKargoKuryeIslemleriDetay = Loader(lazy(() => import('./content/pages/KurumDisiKargoKuryeIslemleri/Detay')));
const KurumDisiRaporIstatistik = Loader(lazy(() => import('./content/pages/KurumDisiRaporIstatistik')));
//Patoloji Modulu
const PatolojiNumuneKabul = Loader(lazy(() => import('./content/pages/PatolojiModulu/NumuneKabul')));
const PatolojiRaporIslemleri = Loader(lazy(() => import('./content/pages/PatolojiModulu/RaporIslemleri')));
const PatolojiLaboratuvarIslemleri = Loader(lazy(() => import('./content/pages/PatolojiModulu/LaboratuvarIslemleri')));
const PatolojiArsivleme = Loader(lazy(() => import('./content/pages/PatolojiModulu/Arsivleme/DolapTanim')));
const PatolojiArsivlemeArsivHareketleri = Loader(lazy(() => import('./content/pages/PatolojiModulu/Arsivleme/ArsivHareketleri')));
const PatolojiHastaRaporSonuclari = Loader(lazy(() => import('./content/pages/PatolojiModulu/HastaRaporSonuclari')));
//Sonuç İzleme
const SonucIzleme = Loader(lazy(() => import('./content/pages/SonucIzleme')));

//transactions
const MailGonderimIzleme = Loader(lazy(() => import('./content/pages/MailGonderimIzleme')));




const Duyuru = Loader(lazy(() => import('./content/pages/Duyuru')));
const DilIslemleri = Loader(lazy(() => import('./content/pages/Settings/dil.islemleri')));
const PaketTanim = Loader(lazy(() => import('./content/pages/Settings/Generals/PaketTanim')));
const ExceptionLog = Loader(lazy(() => import('./content/pages/Log/exception')));
const DuyuruListe = Loader(lazy(() => import('./content/pages/Duyuru/liste')));
const VerikontrolIndex = Loader(lazy(() => import('./content/pages/Settings/Generals/verikontrol')));
const FaturaTanim = Loader(lazy(() => import('./content/pages/Fatura/Tanim')));
const RandevuWithProvider = Loader(lazy(() => import('./content/pages/Randevu/RandevuPlanlama')));
const FaturaIzlemeEkrani = Loader(lazy(() => import('./content/pages/Fatura/IzlemeEkrani')));
const KararDestek = Loader(lazy(() => import('./content/pages/KararDestek/KararDestek')));
const ReportViewer = Loader(lazy(() => import('./content/pages/KararDestek/ReportViewer')));
const TestTanimContextProvider = Loader(lazy(() => import('./content/pages/GenelTanimlar/Context/GenelTanimlarProvider')));
const ReferansDoktorListe = Loader(lazy(() => import('./content/pages/GenelTanimlar/ReferansDoktor/Liste')));
const ReferansDoktorForm = Loader(lazy(() => import('./content/pages/GenelTanimlar/ReferansDoktor/Form')));
const ReferansDoktorEkle = Loader(lazy(() => import('./content/pages/GenelTanimlar/ReferansDoktor/Ekle')));
const PersonelEkle = Loader(lazy(() => import('./content/pages/GenelTanimlar/Personel/PersonelEkle')));
const PersonelForm = Loader(lazy(() => import('./content/pages/GenelTanimlar/Personel/PersonelForm')));
const PersonelListe = Loader(lazy(() => import('./content/pages/GenelTanimlar/Personel/PersonelListe')));
const Kimlik = Loader(lazy(() => import('./content/pages/Kimlik')));
const VezneYetki = Loader(lazy(() => import('./content/pages/Yetki/VezneYetki/VezneYetki')));
const VezneMakbuzIzlemeListe = Loader(lazy(() => import('./content/pages/Vezne/MakbuzIzleme/Liste')));
const LaboratuvarIzleme = Loader(lazy(() => import('./content/pages/LaboratuvarIzleme')));
const FaturaKurumIcmalleri = Loader(lazy(() => import('./content/pages/Fatura/KurumIcmalleri')));
const DrHakedis = Loader(lazy(() => import('./content/pages/DrHakedis')));
const Main = Loader(lazy(() => import('./content/pages/HastaKayit/main')));
const MuracaatDetay = Loader(lazy(() => import('./content/pages/HastaKayit/MuracaatDetay')));
const MuracaatDetayliArama = Loader(lazy(() => import('./content/pages/HastaKayit/muracaat.detayli.arama')));
const HastaServisListe = Loader(lazy(() => import('./content/pages/HastaServis/HastaServisListe')));
const HastaServisDetay = Loader(lazy(() => import('./content/pages/HastaServis/HastaServisDetay')));
const HemsireIsliste = Loader(lazy(() => import('./content/pages/HemsireIsListesi')));
const RaporTipleri = Loader(lazy(() => import('./content/pages/Raporlama/Tanim/RaporTipleri')));
const MuracaatIzlem = Loader(lazy(() => import('./content/pages/MuracaatIzlem')));
const IslemRaporListesi = Loader(lazy(() => import('./content/pages/GenelTanimlar/IslemTanimlari/IslemRaporlari/RaporListesi')));
const DepoTanimlari = Loader(lazy(() => import('./content/pages/StokEczane/DepoTanimlari')));
const DepoDonemleri = Loader(lazy(() => import('./content/pages/StokEczane/DepoDonemleri')));
const UrunTanimlari = Loader(lazy(() => import('./content/pages/StokEczane/UrunTanimlari')));
const GirisIslemleri = Loader(lazy(() => import('./content/pages/StokEczane/GirisIslemleri')));
const UrunDuzenle = Loader(lazy(() => import('./content/pages/StokEczane/UrunTanimlari/urunDuzenle')));
const GirisEkle = Loader(lazy(() => import('./content/pages/StokEczane/GirisIslemleri/girisEkle')));
const DepoTanimEkle = Loader(lazy(() => import('./content/pages/StokEczane/DepoTanimlari/depoTanimEkle')));
const KDHastaKayit = Loader(lazy(() => import('./content/pages/KurumDisiHastaKayit')));
const KonsultasyonMain = Loader(lazy(() => import('./content/pages/HastaServis/Order/Konsultasyon/Konsultasyon')));
const YatisKabulMain = Loader(lazy(() => import('./content/pages/YatisKabul/YatisKabulMain')));
const CikisList = Loader(lazy(() => import('./content/pages/StokEczane/CikisIslemleri')));
const CikisEkle = Loader(lazy(() => import('./content/pages/StokEczane/CikisIslemleri/cikisEkle')));
const ServisProtokol12Table = Loader(lazy(() => import('./content/pages/GenelTanimlar/ServisProtokolTanim/ServisProtokol12Table')));
const YatakGrupTanim = Loader(lazy(() => import('./content/pages/GenelTanimlar/YatakTanim/YatakGrupTanim')));
const NKPLaboratuvarCalismaEkrani = Loader(lazy(() => import('./content/pages/PatolojiModulu/LaboratuvarIslemleri/CalismaEkrani')));
const RaporlamaRaporGruplari = Loader(lazy(() => import('./content/pages/Raporlama/Tanim/RaporGruplari')));
const PatolojiArsivlemeDetay = Loader(lazy(() => import('./content/pages/PatolojiModulu/Arsivleme/DolapTanim/Detay')));
const CihazTanim = Loader(lazy(() => import('./content/pages/Radyoloji/CihazTanim')));
const CihazTestTanim = Loader(lazy(() => import('./content/pages/Radyoloji/CihazTestTanim')));
const RandevuSablonTanim = Loader(lazy(() => import('./content/pages/Radyoloji/RandevuSablonTanim')));
const HesapPlan = Loader(lazy(() => import('./content/pages/MuhasebeModulu/HesapPlan')));
const MuhasebeIslemler = Loader(lazy(() => import('./content/pages/MuhasebeModulu/MuhasebeIslemler')));
const MuhasebeIslemlerDetay = Loader(lazy(() => import('./content/pages/MuhasebeModulu/MuhasebeIslemler/MuhasebeIslemlerDetay')));
const RadyolojiKabul = Loader(lazy(() => import('./content/pages/Radyoloji/RadyolojiKabul')));
const RadyolojiIslem = Loader(lazy(() => import('./content/pages/Radyoloji/RadyolojiIslem')));
const RadyolojiIslemDetaylar = Loader(lazy(() => import('./content/pages/Radyoloji/RadyolojiIslem/Detaylar')));
const CihazRandevu = Loader(lazy(() => import('./content/pages/Radyoloji/CihazRandevu')));
const KullaniciVTYSTanim = Loader(lazy(() => import('./content/pages/Settings/Generals/KullaniciVYSTanim/index')));
const SablonTanimlari = Loader(lazy(() => import('./content/pages/Settings/Generals/SablonTanimlari')));
const EmirKullanici = Loader(lazy(() => import('./content/pages/Kullanici')));
const Egitim = Loader(lazy(() => import('./content/pages/Egitim')));
const SozlesmeIzleme = Loader(lazy(() => import('./content/pages/Islemler/SozlesmeIzleme')));
const PatolojiRaporKurtar = Loader(lazy(() => import('./content/pages/PatolojiModulu/RaporKurtar')));
const OrderTalepMain = Loader(lazy(() => import('./content/pages/StokEczane/DepoHareketler/OrderTalepKabul')));
const DepoTalepKabul = Loader(lazy(() => import('./content/pages/StokEczane/DepoHareketler/DepoTalepKabul')));
const DepoDurumMain = Loader(lazy(() => import('./content/pages/StokEczane/DepoHareketler/DepoDurumu')));
const DepoTalep = Loader(lazy(() => import('./content/pages/StokEczane/DepoHareketler/DepoTalep')));
export const Routes2 = (props: { bolumSecildi: boolean }): JSX.Element => {
  return (
    <RequireAuth>
      <Routes>
        <Route path="*" element={<Status404 />}></Route>
        <Route path="/" element={props.bolumSecildi ? <SidebarLayout /> : <Login />}>
          <Route path="duyuru" element={<Duyuru />}></Route>
          <Route path="login" element={<Login />}></Route>
          <Route path="logout" element={<Logout />}></Route>
          <Route path="status" element={<Status404 />}>
            <Route path="404" element={<Status404 />}></Route>
            <Route path="500" element={<Status500 />}></Route>
            <Route path="maintenance" element={<StatusMaintenance />}></Route>
            <Route path="coming-soon" element={<StatusComingSoon />}></Route>
          </Route>
          <Route path="management">
            <Route path="generals">
              <Route path="verikontrol" element={<VerikontrolIndex />}></Route>
              <Route path="tele-diagnosis-tanim" element={<TeleDiagnosisTanim />}></Route>

              <Route path="kimlik-detay" element={<Kimlik />}></Route>
              <Route path="kullanici-tanim">
                <Route index element={<KullaniciTanim />} />
                <Route path="detay" element={<KullaniciTanimDetay />} />
              </Route>
              <Route path="personel-tanim">
                <Route index element={<PersonelListe />} />
                <Route path="detay" element={<PersonelForm />}></Route>
                <Route path="ekle" element={<PersonelEkle />}></Route>
              </Route>
              <Route path="gnlparametre" element={<ParametreTanimlari />}></Route>
              <Route path="servisTanim" element={<ServisTanim />}></Route>
              <Route path="servisPersonel" element={<ServisPersonel />}></Route>
              <Route path="bransTanim" element={<BransTanim />}></Route>
              <Route path="kurumTanim" element={<KurumTanim />}></Route>
              <Route path="modulTanim" element={<ModulTanim />}></Route>
              <Route path="kurumTarife" element={<KurumTarife />}></Route>
              <Route path="organizasyontarife" element={<OrganizasyonTarife />}></Route>
              <Route path="kullanicitarife" element={<KullaniciTarife />}></Route>
              <Route path="ucretTarifeIslem" element={<TarifeIslem />}></Route>
              <Route path="ucretTarifeTanim" element={<UcretTarifeTanim />}></Route>
              <Route path="veznetanim" element={<VezneTanim />}></Route>
              <Route path="faturatanim" element={<FaturaTanim />}></Route>
              <Route path="indirimtanim" element={<IndirimTanim />}></Route>
              <Route path="tanitanim" element={<HastalikTanim />}></Route>
              <Route path="dilIslem" element={<DilIslemleri />}></Route>
              <Route path="referans-doktor">
                <Route index element={<ReferansDoktorListe />} />
                <Route path="ekle" element={<ReferansDoktorEkle />}></Route>
                <Route path="detay" element={<ReferansDoktorForm />}></Route>
              </Route>
              <Route path="organizasyon-tanim" element={<OrganizasyonTanim />}></Route>

              <Route path="servis-protokol-tanim">
                <Route index element={<ServisProtokol12Table />} />
                {/* <Route path="" element={< />}></Route>
                    <Route path="" element={< />}></Route> */}
              </Route>

              <Route path="yatak-tanim" element={<YatakGrupTanim />}></Route>
              <Route path="sablon-tanim" element={<SablonTanimlari />} />

              <Route path="kurumMailGonderimAyarlari" element={<KurumMailGonderimAyarlari />}></Route>
              <Route path="sonucIzlemeTanim" element={<SonucIzlemeTanim />}></Route>

            </Route>

            <Route path="tetkik">
              <Route path="islemtanimi">
                <Route index element={<IslemTanim />} />
                <Route path="rapor-listesi" element={<IslemRaporListesi />} />
              </Route>
              <Route path="islembolum" element={<IslemBolum />}></Route>
              <Route path="istempanelhasta" element={<IstemPanelHasta />}></Route>
              <Route path="istempaneltanim" element={<IstemPanelTanim />}></Route>
              <Route path="pakettanim" element={<PaketTanim />}></Route>
              <Route path="rapor-tipleri">
                <Route index element={<RaporTipleri />} />
                <Route path="rapor-gruplari" element={<RaporlamaRaporGruplari />} />
                <Route path="rapor-personelleri" element={<RaporPeronel />} />
              </Route>
            </Route>
            <Route path="authority">
              <Route path="roltanimlari" element={<GnlRolTanim />}></Route>
              <Route path="yetkiTanim" element={<YetkiTanim />}></Route>
              <Route path="userrole" element={<KullaniciYetkiIndex />}></Route>
              <Route path="organization" element={<OrganizasyonYetki />}></Route>
              <Route path="role" element={<RolYetkiIndex />}></Route>
              <Route path="kullanici-vezne-atama" element={<VezneYetki />}></Route>
              <Route path="kullanicivtysyetki" element={<KullaniciVTYSTanim />}></Route>
            </Route>
          </Route>
          <Route path="log">
            <Route path="exception" element={<ExceptionLog />}></Route>
            <Route path="egitim" element={<Egitim />}></Route>
          </Route>
          <Route path="systems">
            <Route path="hastakayit">
              <Route index element={<Main />}></Route>
              <Route path="detay" element={<MuracaatDetay />}></Route>
              <Route path="detayli-arama" element={<MuracaatDetayliArama />}></Route>
              <Route path="kimlik" element={<Kimlik />}></Route>
            </Route>
            <Route path="kurumdisi">
              <Route path="hasta-kayit">
                <Route index element={<KDHastaKayit />}></Route>
                <Route path="detay" element={<MuracaatDetay />}></Route>
                <Route path="kimlik" element={<Kimlik />}></Route>
                <Route path="detayli-arama" element={<MuracaatDetayliArama kurumDisi={true} />}></Route>
              </Route>
              <Route path="kargo-kurye-islemleri">
                <Route index element={<KurumDisiKargoKuryeIslemleri />} />
                <Route path="detay" element={<KurumDisiKargoKuryeIslemleriDetay />} />
              </Route>
              <Route path="muracaat-izleme" element={<MuracaatIzlem disKurum={true} />} />
              <Route path="rapor-istatistik" element={<KurumDisiRaporIstatistik />} />
            </Route>
            <Route path="vezne-modul">
              <Route index element={<VezneIndex />}></Route>
              <Route path="vezne" element={<VezneIndex />}></Route>
              <Route path="makbuz-izleme" element={<VezneMakbuzIzlemeListe />}></Route>
            </Route>
            <Route path="tedavi-modul">
              <Route index element={<HastaServisListe />} />
              <Route path="tedavi">
                <Route index element={<HastaServisListe />} />
                <Route path="detay" element={<HastaServisDetay />} />
              </Route>
              <Route path="hemsire-is-listesi" element={<HemsireIsliste />}></Route>
            </Route>
            <Route path="randevu" element={<RandevuWithProvider />}></Route>
            <Route path="faturamodul">
              <Route path="fatura" element={<FaturaMain />}></Route>
              <Route path="faturaizleme" element={<FaturaIzlemeEkrani />}></Route>
              <Route path="kurumicmalleri" element={<FaturaKurumIcmalleri />}></Route>
            </Route>
            <Route path="karar-destek">
              <Route index element={<KararDestek />}></Route>
              <Route path="viewer" element={<ReportViewer />}></Route>
            </Route>
            <Route path="stokeczane">
              <Route path="depotanimlari">
                <Route index element={<DepoTanimlari />} />
                <Route path="depoTanimEkle" element={<DepoTanimEkle />} />
              </Route>
              <Route path="depodonemleri" element={<DepoDonemleri />}></Route>
              <Route path="uruntanimlari">
                <Route index element={<UrunTanimlari />} />
                <Route path="urunDuzenle" element={<UrunDuzenle />} />
              </Route>
              <Route path="girisislemleri">
                <Route index element={<GirisIslemleri />} />
                <Route path="girisEkle">
                  <Route index element={<GirisEkle />} />
                </Route>
              </Route>
              <Route path="cikisislemleri">
                <Route index element={<CikisList />} />
                <Route path="cikisEkle" element={<CikisEkle />} />
              </Route>
              <Route path="depodurum" element={<DepoDurumMain />} />
              <Route path="ordertalepkabul" element={<OrderTalepMain />} />
              <Route path="depotalepkabul" element={<DepoTalepKabul />} />
              <Route path="depotalep" element={<DepoTalep />} />
            </Route>
            <Route path="yatiskabul">
              <Route index element={<YatisKabulMain />}></Route>
            </Route>
            <Route path="patoloji-modulu">
              <Route path="numune-kabul">
                <Route index element={<PatolojiNumuneKabul />} />
              </Route>
              <Route path="laboratuvar-islemleri">
                <Route index element={<PatolojiLaboratuvarIslemleri />} />
                <Route path="calisma-listesi">
                  <Route index element={<NKPLaboratuvarCalismaEkrani />} />
                  <Route path="kimlik" element={<Kimlik />}></Route>
                </Route>
              </Route>
              <Route path="rapor-islemleri">
                <Route index element={<PatolojiRaporIslemleri />} />
              </Route>
              <Route path="arsivleme">
                <Route path="dolap-tanim">
                  <Route index element={<PatolojiArsivleme />} />
                  <Route path="detay" element={<PatolojiArsivlemeDetay />} />
                </Route>
                <Route path="arsiv-hareketleri">
                  <Route index element={<PatolojiArsivlemeArsivHareketleri />} />
                </Route>
              </Route>
              <Route path="hasta-rapor-sonuclari">
                <Route index element={<PatolojiHastaRaporSonuclari />} />
              </Route>
              <Route path="patoloji-rapor-kurtar" element={<PatolojiRaporKurtar />} />
            </Route>
            <Route path="radyoloji-modulu">
              <Route path="cihaz-tanim">
                <Route index element={<CihazTanim />} />
              </Route>
              <Route path="cihaz-test-tanim">
                <Route index element={<CihazTestTanim />} />
              </Route>
              <Route path="randevu-sablon-tanim">
                <Route index element={<RandevuSablonTanim />} />
              </Route>
              <Route path="cihaz-randevu">
                <Route index element={<CihazRandevu />} />
              </Route>
              <Route path="radyolojikabul">
                <Route index element={<RadyolojiKabul />} />
                <Route path="detaylar">
                  <Route index element={<RadyolojiIslemDetaylar />} />
                  <Route path="kimlik" element={<Kimlik />} />
                </Route>
              </Route>
              <Route path="radyolojiislemler">
                <Route index element={<RadyolojiIslem />} />
                <Route path="detaylar">
                  <Route index element={<RadyolojiIslemDetaylar />} />
                  <Route path="kimlik" element={<Kimlik />} />
                </Route>
              </Route>
            </Route>
            <Route path="muhasebe-modul">
              <Route path="muhasebe-islemler">
                <Route index element={<MuhasebeIslemler />} />
                <Route path="detay" element={<MuhasebeIslemlerDetay />} />
              </Route>

              <Route path="hesap-plan">
                <Route index element={<HesapPlan />} />
                {/* <Route path="ekle" element={<ReferansDoktorEkle />}></Route>
                <Route path="detay" element={<ReferansDoktorForm />}></Route> */}
              </Route>
            </Route>
            <Route path="sonuc-izleme">
              <Route index element={<SonucIzleme />} />
            </Route>
          </Route>
          <Route path="transactions">
            <Route path="duyuruliste" element={<DuyuruListe />}></Route>
            <Route path="rezervbarkod" element={<RezervBarkod />}></Route>
            <Route
              path="istempanel"
              element={
                <TestTanimContextProvider>
                  <IstemPanel />
                </TestTanimContextProvider>
              }
            ></Route>
            <Route path="drhakedis" element={<DrHakedis />}></Route>
            <Route path="poscihaztanim" element={<VeznePosCihazTanim />}></Route>
            <Route path="laboratuvar-izleme" element={<LaboratuvarIzleme></LaboratuvarIzleme>}></Route>
            <Route path="muracaat-izleme" element={<MuracaatIzlem />}></Route>
            <Route path="mail-gonderim-izleme" element={<MailGonderimIzleme />} />
            <Route path="sozlesme-izleme" element={<SozlesmeIzleme />} />
            <Route path="kurum-bonus-tanim">
              <Route index element={<KurumBonusTanimlari />} />
              <Route path="test-bazli" >
                <Route index element={<KurumBonusTanimlariTestBazli />} />
                <Route path="test-ve-veriye-gore" element={<KurumBonusTanimlariTestVeVeriyeGore />} />
              </Route>
            </Route>
          </Route>
          <Route path="konsultasyon" element={<KonsultasyonMain />} />
          <Route path="yataktanim" element={<YatakGrupTanim />} />
          <Route path="emirkullanici" element={<EmirKullanici />} />
        </Route>
      </Routes>
    </RequireAuth>
  );
};

export default Routes2;
